<template>
  <div class="tab">
    <div class="tab-button">
      <span :key="['tab-button', idx].join('-')" v-for="(item, idx) in items">
        <input :id="['tab-button', idx].join('-')" type="radio" :checked="tabidx===idx" @click="tabchage(idx)"/>
        <label :for="['tab-button', idx].join('-')">{{ item.title }}</label>
      </span>
    </div>
    <div class="tab-page">
      <div :key="['tab-page', idx].join('-')" v-for="(item, idx) in items" v-show="tabidx===idx">
        <slot :name="['tab-page', idx].join('-')"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tab',
  props: {
    items: {
      type: Array,
      default: function(){
        return [];
      },
    },
    index: {
      type: Number,
      default: -1
    }
  },
  data: () => ({
    tabidx: -1,
  }),
  methods: {
    tabchage(index){
      this.tabidx = index;
      this.$emit('update:index', index)
    },
  },
  mounted(){
    this.tabidx = ~~this.index;
  },
  computed: {
  },
};
</script>
<style lang="scss" scoped>
  .tab-button{
    margin: 0px;
    display: flex;
    > * {
        flex: 1 1 auto;
    }

    input[type=radio] {
      display: none;
      &:checked {
        + label {
          background-color: #0059a9;
          color: #fff;
        }
      }
    }
    label {
      color: #0059a9;
      border: 1px solid #0059a9;
      margin: 5px 0px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
